import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";

const UsedCarWarrantyPurchased = () => {
  const { pfAdLookupLinks } = useAppConfig();
  const usedCarGuarantee = pfAdLookupLinks?.usedCarGuaranteeSafetyElement;

  if (!usedCarGuarantee) {
    return null;
  }

  return (
    <div>
      <p className="mb-0">{usedCarGuarantee.content}</p>
      <p className="mb-0 mt-16 md:mt-8">
        <strong>{usedCarGuarantee.terms}</strong>
      </p>
      <p className="mb-0 mt-16 md:mt-8">
        <a href={usedCarGuarantee.href}>{usedCarGuarantee.linkText}</a>
      </p>
    </div>
  );
};

export default UsedCarWarrantyPurchased;
